import { DocumentType } from 'api';
import { SelectOption } from 'form';

export const DOCUMENT_TYPE_DISPLAYED_VALUE: Record<DocumentType, string> = {
  [DocumentType.A7]: 'Annex VII',
  [DocumentType.BC]: 'Booking Confirmation',
  [DocumentType.BDP]: 'Buyer Document Pack',
  [DocumentType.BIN]: 'Buyer Invoice',
  [DocumentType.BOL]: 'Bill Of Lading',
  [DocumentType.CAR]: 'Certificate of Chemical Analysis Report',
  [DocumentType.CI]: 'Commercial Invoice',
  [DocumentType.CMR]: 'Driver CMR',
  [DocumentType.COA]: 'Certificate of Analysis',
  [DocumentType.COO]: 'Certificate Of Origin',
  [DocumentType.CR]: 'Quality Report',
  [DocumentType.SCR]: 'Trade Company Session Quality Report',
  [DocumentType.DN]: 'Delivery Note',
  [DocumentType.DP]: 'DP Document Pack',
  [DocumentType.DPP]: 'DP Document Pack Cover Sheet',
  [DocumentType.DSP]: 'Draft Shipping Instructions',
  [DocumentType.ECF]: 'Export Collection Form',
  [DocumentType.ED]: 'Export Declaration',
  [DocumentType.F6]: 'Form 6',
  [DocumentType.F9]: 'Form 9',
  [DocumentType.GLC]: 'Green List Contract',
  [DocumentType.IL]: 'Import License',
  [DocumentType.IN]: 'Indent',
  [DocumentType.IR]: 'Inspection Report',
  [DocumentType.OT]: 'Other (Hidden)',
  [DocumentType.OTA]: 'Other (Visible to buyer and supplier)',
  [DocumentType.OTB]: 'Other Buyer (Visible to buyer)',
  [DocumentType.OTI]: 'Other Invoice (Hidden)',
  [DocumentType.OTS]: 'Other Supplier (Visible to supplier)',
  [DocumentType.PL]: 'Packing List',
  [DocumentType.PO]: 'Purchase Order',
  [DocumentType.PO2]: 'Purchase Order',
  [DocumentType.PSI]: 'Pre-Shipment Inspection Certificate',
  [DocumentType.RPL]: 'Road Packing List',
  [DocumentType.SC]: 'Self Certification',
  [DocumentType.SD]: 'Self Declaration',
  [DocumentType.SIN]: 'Supplier Invoice',
  [DocumentType.SLS]: 'Supplier Loading Schedule',
  [DocumentType.SO]: 'Sales Order',
  [DocumentType.SO2]: 'Sales Order',
  [DocumentType.SP]: 'Shipping Instructions',
  [DocumentType.SPL]: 'Supplier Packing List',
  [DocumentType.SWB]: 'Seaway Bill',
  [DocumentType.T2L]: 'T2L',
  [DocumentType.VGM]: 'Verified Gross Mas',
  [DocumentType.WCL]: "Waste Carrier's License",
  [DocumentType.WT]: 'Weighbridge Ticket',
  [DocumentType.WTN]: 'Waste Transfer Note',
};

export const DOCUMENT_TYPE_OPTIONS: SelectOption[] = Object.entries(DocumentType)
  .map(([_, value]) => ({
    label: DOCUMENT_TYPE_DISPLAYED_VALUE[value],
    value: value,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));
